__turbopack_context__.v({
  "acceptButton": "CookieConsent-module-scss-module__PLk-IW__acceptButton",
  "description": "CookieConsent-module-scss-module__PLk-IW__description",
  "privacyLink": "CookieConsent-module-scss-module__PLk-IW__privacyLink",
  "wrapper": "CookieConsent-module-scss-module__PLk-IW__wrapper",
});
